import { useField } from 'formik'
import { FC } from 'react'

import { PostalCodeInput, PostalCodeInputProps } from './PostalCodeInput'

type Props = Omit<PostalCodeInputProps, 'name' | 'onChange' | 'value' | 'fourthLevelAdministrativeDivisionId'> & {
  name: string
  onChange?: (value: string) => void
}

const PostCodeInputField: FC<Props> = ({ name, onChange, ...props }) => {
  const [field, , helper] = useField(name)
  
  const handleChange = (value: string) => {
    helper.setValue(value)
    onChange?.(value)
  }

  return (
    <PostalCodeInput
      {...field}
      {...props}
      onChange={handleChange}
      isDisabled={props.isDisabled}
    />
  )
}

export { PostCodeInputField }
